export default __webpack_public_path__ + "static/media/d-horse.2257b524.png";